import {MenuItem, SelectField} from 'material-ui';
import React, {PropTypes} from 'react';

export default function Select({id, name, label, children, options, ...props}) {
  return (
    <SelectField
      floatingLabelText={label}
      autoWidth
      onChange={this.handleChange}
      value={this.state.value}>
      {options.map(option => <MenuItem value={option.value} primaryText={option.label} />)}
    </SelectField>
  );
}

Select.propTypes = {
  children: PropTypes.element,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]).isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ])
    ),
    PropTypes.string,
    PropTypes.number
  ]).isRequired
};



// WEBPACK FOOTER //
// ./app/features/shared/components/Select.js